import React, { useState } from "react";
import { Button, message, Steps, theme } from "antd";
import { Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";
import BasicDetails from "./Steps/basic";
import AttributesDetails from "./Steps/attributes";
import ProductDetails from "./Steps/product";
import { destore } from "../../store/features/product/productSlice";

const CreateProduct = () => {
  const { token } = theme.useToken();
  const productStoreDetails = useSelector((state) => state.product.product);
  const [current, setCurrent] = useState(0);
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const steps = [
    {
      title: "Basic Details",
      content: <BasicDetails />,
    },
    {
      title: "Select Attributes",
      content: <AttributesDetails />,
    },
    {
      title: "Create Product",
      content: <ProductDetails />,
    },
  ];

  const next = () => {
    if (productStoreDetails && productStoreDetails.categoryId != "") {
      setCurrent(current + 1);
    }
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const handleSubmit = async () => {
    try {
      let priceDetails = localStorage.getItem("productDetails");
      priceDetails = JSON.parse(priceDetails);
      let productsInfo = {
        name: productStoreDetails.name,
        categoryId: productStoreDetails.categoryId,
        variant: productStoreDetails.variants,
        attributes: priceDetails,
        price: productStoreDetails.price,
        desc: productStoreDetails.desc,
        inputs: productStoreDetails.inputs,
        images: productStoreDetails.images,
        demoVideo: productStoreDetails.demoVideo,
        sizeRef: productStoreDetails.sizeRef,
        howToOrderLabel: productStoreDetails.howToOrderLabel,
        sizeRefLabel: productStoreDetails.sizeRefLabel,
        catalogueLabel: productStoreDetails.catalogueLabel,
        catalogue: productStoreDetails.catalogue,
        webPrice: productStoreDetails.webPrice,
        courierType: productStoreDetails.courierType,
        courier: productStoreDetails.courierAmount,
      };
      const data = await axios
        .post("/product-create", productsInfo)
        .catch((error) => {
          Helper.ErrorHanlder(error);
        });
      if (data && data.data) {
        message.success("Product created successfully");
        localStorage.removeItem("productDetails");
        dispatch(destore());
        navigate("/products");
      }
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  };

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const contentStyle = {
    lineHeight: "260px",
    textAlign: "center",
    color: token.colorTextTertiary,
    backgroundColor: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    border: `1px dashed ${token.colorBorder}`,
    marginTop: 16,
  };

  return (
    <Container>
      <Row>
        <Steps current={current} items={items} />
        <div style={contentStyle}>{steps[current].content}</div>
        <div
          style={{
            marginTop: 24,
          }}
        >
          {current < steps.length - 1 && (
            <Button type="primary" onClick={() => next()}>
              Next
            </Button>
          )}
          {current === steps.length - 1 && (
            <Button type="primary" onClick={() => handleSubmit()}>
              Done
            </Button>
          )}
          {current > 0 && (
            <Button
              style={{
                margin: "0 8px",
              }}
              onClick={() => prev()}
            >
              Previous
            </Button>
          )}
        </div>
      </Row>
    </Container>
  );
};
export default CreateProduct;
